module.exports = __webpack_public_path__ + "img/serifnew_box03.fa8bafce.jpg";